import { Injectable } from '@angular/core';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { NOME_MARCA } from './../../../environments/environment';

@Injectable()
export class PrintPdfService {
  nomeModulo: string;
  tituloTabela: string;
  textoData: string;
  carregando: boolean;
  private logo: string;

  constructor() {
    this.logo = NOME_MARCA
  }

  public exportPDFA4(data?: string) {
    this.exportPDF('print-section', data.substring(0, 10));
  }

  public exportPDFA4SemData(): any {
    this.exportPDFSemData('print-section');
    return 'result';
  }

  public exportPDF(idTabela: string, dataRef?: string) {
    const data = document.getElementById(idTabela);
    html2canvas(data).then(canvas => {
      const imgWidth = 297;
      const pageHeight = 398;
      const imgHeight = canvas.height * imgWidth / canvas.width;
      const heightLeft = imgHeight;
      const contentDataURL = canvas.toDataURL('image/png');
      const pdf = new jsPDF('l', 'mm', 'a4');
      const position = 20;

      const data = dataRef;
      this.textoData = this.textoData + data;

      pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight);
      pdf.text(this.textoData, 238, 13);
      pdf.text(this.tituloTabela, 5, 13);
      pdf.setPage(1);
      pdf.save(this.nomeModulo);
    });
  }

  public exportPDFSemData(idTabela: string) {
    const data = document.getElementById(idTabela);
    html2canvas(data).then(canvas => {
      const imgWidth = 210;
      const pageHeight = 297;
      const imgHeight = canvas.height * imgWidth / canvas.width;
      let heightLeft = imgHeight;
      const contentDataURL = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm');
      let position = 30;

      const logo_triumph = "/assets/img/logo_site_triumph.png";
      const logo_volvo = "/assets/img/logo_site_volvo.png";
      const logo_harley = "/assets/img/logo_site_harley.png";
      const logo_porsche = "/assets/img/logo_site_porsche.png";
      const logo_stuttgart = "/assets/img/logo_site_stuttgart.png";
      const logo_gwm = "/assets/img/logo_site_gwm.png";
      const logo_byd = "/assets/img/logo_site_byd.png";
      const logo_nbs = "/assets/img/logo_site_nbs.png";

      pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      if (this.logo === "Triumph") {
        pdf.addImage(logo_triumph, 'png', 2, 2, 20, 20);
      } else if (this.logo === "Volvo") {
        pdf.addImage(logo_volvo, 'png', 2, 2, 20, 20);
      } else if (this.logo === "Harley") {
        pdf.addImage(logo_harley, 'png', 2, 2, 20, 20);
      } else if (this.logo === "Porsche") {
        pdf.addImage(logo_porsche, 'png', 2, 2, 20, 20);
      } else if (this.logo === "Stuttgart") {
        pdf.addImage(logo_stuttgart, 'png', 2, 2, 20, 20);
      } else if (this.logo === "GWM") {
        pdf.addImage(logo_gwm, 'png', 2, 2, 20, 20);
      } else if (this.logo === "BYD") {
        pdf.addImage(logo_byd, 'png', 2, 2, 20, 20);
      } else if (this.logo === "NBS") {
        pdf.addImage(logo_nbs, 'png', 2, 2, 20, 20);
      }

      pdf.text(this.tituloTabela, 138, 10);

      while (heightLeft >= 0) {
        position += heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      pdf.save(this.nomeModulo);
    });
  }
}
